import React from 'react';
import { useParams } from 'react-router-dom';
import Choose from './choosePerso';  // Importer le composant pour le plan 1

const PlanDetail = () => {
  const { planPersoId } = useParams(); // Récupère l'ID du plan depuis l'URL

  // Rendre le bon composant en fonction du plan sélectionné
  let planComponent;
  
    planComponent = <Choose planId={planPersoId} />;

  return (
    <div>
      {planComponent} {/* Affiche le composant en fonction de l'ID du plan */}
    </div>
  );
};

export default PlanDetail;
